import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=abed56b8"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports